
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import SummaryHeader from './SummaryHeader.vue'
import SummaryStudyData from './SummaryStudyData.vue'
import SummaryStudyProcess from './SummaryStudyProcess.vue'
import SummaryHomework from './SummaryHomework.vue'
import SummaryActionData from './SummaryActionData.vue'
import SummaryDairy from './SummaryDairy.vue'
import SummaryStudyRecord from './SummaryStudyRecord.vue'
import Navbar from '../Navbar/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import SummarySharedModal from '@xt/www/components/summarySharedModal/index.vue'
import { type sharedModalData } from '@xt/www/components/summarySharedModal/index.vue'
import { getFirstThreeElements } from '@xt/client/utils/summary/index'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import type { HomeworkOption, DairyOption } from '@xt/client/entities/course-v2/user-content'

@Observer
@Component({
  components: {
    Navbar,
    SummaryHeader,
    SummaryStudyData,
    SummaryStudyProcess,
    SummaryHomework,
    SummaryActionData,
    SummaryDairy,
    SummaryStudyRecord,
    LazyImg,
    UserContentPop,
    SummarySharedModal
  }
})
export default class StudySummary extends Vue {
  @Prop({ required: true }) visible: boolean
  @Prop({ required: true }) courseId: string

  visibleSummaryModal: boolean = false
  sharedData: sharedModalData | null = null

  @Ref()
  userContentPop: {
    showPop: (options: HomeworkOption | DairyOption) => void
    hidePop: () => void
  }

  @Ref()
  summaryHeader: {
    handlePlay: () => void
  }

  onOpenContent(data: HomeworkOption | DairyOption) {
    const { type } = data

    if (type === 'homework') {
      if (!data.homeworkId) return

      this.userContentPop?.showPop({
        type,
        homeworkId: data.homeworkId
      })
    } else {
      if (!data.momentId) return

      this.userContentPop?.showPop({
        type,
        momentId: data.momentId
      })
    }
  }

  showSummaryModal(show: boolean) {
    if (!this.PageStore.basicData || !this.PageStore.actionData || !this.PageStore.sharedModalData) return

    this.sharedData = {
      ...this.PageStore.sharedModalData,
      userId: this.UserStore.UserInfo.id,
      recordList: getFirstThreeElements(this.toJS(this.PageStore.recordList))
    }

    this.visibleSummaryModal = show
  }

  @Emit('close')
  onClose() {}

  @Emit('closed')
  onClosed() {}

  get UserStore() {
    return this.$store.$storeUser
  }

  get PageStore() {
    return this.$store.$courseV2.Summary
  }

  @Watch('visible', { immediate: true })
  updateVisible(val) {
    if (!val) return

    // 学习小结进入后，自动播放声音
    this.$nextTick(() => {
      this.summaryHeader.handlePlay()
    })

    this.PageStore.pageInit(this.courseId)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
